import React from "react";
import TextField from "@mui/material/TextField";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Box,
  Paper,
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText,
  Tooltip
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { red } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";

export default function FormDialog({
  inputForm,
  mode,
  errors,
  readOnly,
  handleInputChange,
  handleShowForm,
}) {

  const navigate = useNavigate();
  const labelWidth = 130;
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChange = (property, event) => {
    const value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;

    handleInputChange(property, value);
  };

  return (
    <Paper>
      <Box sx={{ padding: "20px" }} display="flex" justifyContent="space-between" alignItems="center">
        <span>
          <IconButton
            sx={{ padding: 0, marginBottom: "5px" }}
            onClick={handleShowForm}
          >
            <Tooltip title="Back to Listing" placement="right">
              <KeyboardBackspaceIcon />
            </Tooltip>
          </IconButton>
        </span>
      </Box>
      <Box p={3}>
        <Typography variant="h5" mb={3} fontWeight="fontWeightMedium">
          User Info
        </Typography>
        <Box display="flex" mb={2}>
          <Typography
            display="flex"
            alignItems="center"
            pr={4}
            sx={{ minWidth: labelWidth }}
          >
            Username
          </Typography>
          <TextField
            error={!!errors.userName}
            helperText={errors.userName}
            type="text"
            autoFocus
            onChange={(e) => handleChange("userName", e)}
            value={inputForm.userName}
            required
            id="userName"
            fullWidth
            size="small"
            variant={mode === "view" ? "filled" : "outlined"}
            InputProps={{
              readOnly: readOnly,
            }}
          />
        </Box>
        <Box display="flex" mb={2}>
          <Typography
            display="flex"
            alignItems="center"
            pr={4}
            sx={{ minWidth: labelWidth }}
          >
            Email
          </Typography>
          <TextField
            error={!!errors.email}
            helperText={errors.email}
            onChange={(e) => handleChange("email", e)}
            value={inputForm.email}
            required
            id="email"
            type="email"
            size="small"
            fullWidth
            variant={mode === "view" ? "filled" : "outlined"}
            InputProps={{
              readOnly: readOnly,
            }}
          />
        </Box>

        <Box display="flex" mb={2}>
          <Typography
            display="flex"
            alignItems="center"
            pr={4}
            sx={{ minWidth: labelWidth }}
          >
            Password
          </Typography>

          <FormControl
            fullWidth
            variant="outlined"
            helperText={errors.password}
            error={!!errors.password}
          >
            <OutlinedInput
              type={showPassword ? "text" : "password"}
              size="small"
              fullWidth
              error={!!errors.password}
              onChange={(e) => handleChange("password", e)}
              value={inputForm.password}
              required
              disabled={mode !== "create"}
              variant={mode === "view" ? "filled" : "outlined"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    disabled={mode !== "create"}
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />
            {errors.password && (
              <FormHelperText style={{ color: red[700], fontSize: "0.75rem" }}>
                {errors.password}
              </FormHelperText>
            )}
          </FormControl>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormGroup>
              <Box display="flex" justifyContent="start">
                <Typography
                  display="flex"
                  alignItems="center"
                  pr={4}
                  sx={{ minWidth: labelWidth }}
                >
                  Assign Role
                </Typography>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue={inputForm.roleid}
                  name="radio-buttons-group"
                  row
                  onChange={(e) => handleChange("roleid", e)}
                >
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="Admin"
                  />
                  <FormControlLabel
                    value="2"
                    control={<Radio />}
                    label="Normal User"
                  />
                </RadioGroup>
              </Box>
              <Box display="flex" justifyContent="start">
                <Typography
                  display="flex"
                  alignItems="center"
                  pr={4}
                  sx={{ minWidth: labelWidth }}
                >
                  Active User
                </Typography>
                <FormControlLabel
                  checked={inputForm.isActive}
                  control={<Checkbox />}

                  type="checkbox"
                  onChange={(e) => handleChange("isActive", e)}
                />
              </Box>
            </FormGroup>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
